/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateMailTemplateDto
 */
export interface UpdateMailTemplateDto {
    /**
     * 件名
     * @type {string}
     * @memberof UpdateMailTemplateDto
     */
    subject: string;
    /**
     * プレーンテキスト本文
     * @type {string}
     * @memberof UpdateMailTemplateDto
     */
    bodyText: string;
}

/**
 * Check if a given object implements the UpdateMailTemplateDto interface.
 */
export function instanceOfUpdateMailTemplateDto(value: object): value is UpdateMailTemplateDto {
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('bodyText' in value) || value['bodyText'] === undefined) return false;
    return true;
}

export function UpdateMailTemplateDtoFromJSON(json: any): UpdateMailTemplateDto {
    return UpdateMailTemplateDtoFromJSONTyped(json, false);
}

export function UpdateMailTemplateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateMailTemplateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subject': json['subject'],
        'bodyText': json['bodyText'],
    };
}

export function UpdateMailTemplateDtoToJSON(json: any): UpdateMailTemplateDto {
    return UpdateMailTemplateDtoToJSONTyped(json, false);
}

export function UpdateMailTemplateDtoToJSONTyped(value?: UpdateMailTemplateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subject': value['subject'],
        'bodyText': value['bodyText'],
    };
}

